//export const apiURL = 'https://stopgo.wates.co.uk/api/';
// export const apiURL = 'https://wates-cms-scaffold.dev.psycle.com/api/';
// export const apiURL = 'https://wates-cms-scaffold.dev.psycle.com/api/v1/';
export const apiURL = '/api/v1/';
export const gmAPIKEY = 'AIzaSyC4tkmCM_fD6-ObzTSoKMF6ikXmHPM8cbQ';
export const gmAPIURL = 'https://maps.googleapis.com/maps/api/geocode/json?address=';
